import React from 'react';
import { Box, ChoiceCard, Text } from '@solvhealth/jigsaw-v1';
import {
  InsuranceUploadOption,
  InsuranceUploadOptions,
} from '~/components/Paperwork/components/Payment/PaymentInfoForm';

type Props = {
  shouldShowExistingInsurance: boolean;
  handleInsuranceUploadMethodSelection: (value: InsuranceUploadOptions) => void;
  insuranceUploadOptions: InsuranceUploadOption[];
};

const InsuranceUploadOptionCards = (props: Props) => {
  const {
    shouldShowExistingInsurance,
    handleInsuranceUploadMethodSelection,
    insuranceUploadOptions,
  } = props;
  return (
    <>
      {shouldShowExistingInsurance && (
        <Box pb={3} textAlign="center" width="100%">
          <Text>OR</Text>
        </Box>
      )}
      {insuranceUploadOptions.map((option) => {
        const { icon, label, subtitle, value } = option;
        return (
          <ChoiceCard
            icon={icon}
            key={value}
            onClick={() => {
              handleInsuranceUploadMethodSelection(value);
            }}
            subtitle={subtitle}
            title={label}
            type="button"
          />
        );
      })}
    </>
  );
};

export default InsuranceUploadOptionCards;
